<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="30rem"
    :scrollable="true"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-list-item v-if="list" v-on="{ ...dialog }">
        <v-list-item-icon>
          <v-icon>fa-eraser</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Supprimer un mot clé
        </v-list-item-title>
      </v-list-item>
      <v-btn
        v-else
        v-on="{ ...dialog }"
        :block="$vuetify.breakpoint.xsOnly"
        :class="{ 'mt-2': $vuetify.breakpoint.xsOnly }"
      >
        <v-icon small left>fa-eraser</v-icon>
        Supprimer un mot clé
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <v-spacer></v-spacer>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-form v-model="valid" ref="form" @submit.prevent="save">
        <v-card-text class="pb-0">
          <v-autocomplete
            class="no-before"
            filled
            :items="getAllTags"
            v-model="selectedTag"
            :disabled="loading"
            label="Mot clé à supprimer"
            required
            :rules="[
              v => v !== null || 'Veuillez sélectionner un mot clé',
              v => v !== undefined || 'Veuillez sélectionner un mot clé'
            ]"
          ></v-autocomplete>
          <v-row align="center" class="my-3" no-gutters v-show="loading">
            <v-progress-linear
              indeterminate
              color="primary"
            ></v-progress-linear>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="space-between" no-gutters>
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              :small="!$vuetify.breakpoint.xsOnly"
              :outlined="$vuetify.breakpoint.xsOnly"
              :text="!$vuetify.breakpoint.xsOnly"
              @click="dialog = false"
              :disabled="loading"
            >
              Annuler
            </v-btn>
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              :small="!$vuetify.breakpoint.xsOnly"
              :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
              color="error"
              :disabled="!valid || loading"
              type="submit"
            >
              Supprimer
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "TagManagerTagRemover",
  props: {
    list: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getRecipes", "getProducts", "getTagCategories"]),
    getAllTags() {
      return [
        ...new Set([
          ...this.getRecipes
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getProducts
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getTagCategories.map(x => x.tags).flat()
        ])
      ];
    }
  },
  data() {
    return {
      valid: false,
      dialog: false,
      loading: false,
      selectedTag: undefined
    };
  },
  methods: {
    async save() {
      if (this.valid) {
        try {
          this.loading = true;
          const tasks = [];
          this.getProducts
            .filter(x => x.data !== null)
            .filter(x => x.data.tags.includes(this.selectedTag))
            .forEach(x => {
              if (x.data) {
                const d = {
                  id: x.data.id,
                  tags: x.data.tags.filter(t => t !== this.selectedTag)
                };
                tasks.push(api.patchProductTags(x.data.id, d));
              }
            });
          this.getRecipes
            .filter(x => x.data !== null)
            .filter(x => x.data.tags.includes(this.selectedTag))
            .forEach(x => {
              if (x.data) {
                const d = {
                  id: x.data.id,
                  tags: x.data.tags.filter(t => t !== this.selectedTag)
                };
                tasks.push(api.patchRecipeTags(x.data.id, d));
              }
            });
          this.getTagCategories
            .filter(x => x.tags.includes(this.selectedTag))
            .forEach(x => {
              const d = {
                ...x,
                tags: x.tags.filter(t => t !== this.selectedTag)
              };
              tasks.push(api.patchTagCategory(x.id, d));
            });
          await Promise.all(tasks);
          this.$emit("update");
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        this.selectedTag = null;
        this.$refs.form.reset();
      }
    }
  }
};
</script>

<style></style>
